import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useRef } from "react";

import { useNotifications } from '../NotificationsContext.js';

import List from '../../controls/List.jsx';
import UserDetails from './UserDetails.jsx';
import Toolbar from '../../controls/Toolbar.jsx';
import SearchBar from '../../controls/SearchBar.jsx';

const UserNotifications = ({
  permissions,
}) => {
  const { objectType, id, objectSubType, objectSubTypeId } = useParams();
  const history = useHistory();
  const [translate] = useTranslation();

  const { notificationsData, userIds } = useNotifications();

  const ref = useRef();
  const [searchPrompt, setSearchPrompt] = useState("");

  const baseUrl = `/${objectType}/${id}/${objectSubType}`;

  const nUsers = Object.keys(notificationsData).length;
  const nRegistrations = Object.values(notificationsData).reduce((previousValue, currentValue) => {
    let notRevoked = 0;
    Object.keys(currentValue).forEach(key => {
      if (!currentValue[key].revoked) {
        notRevoked++;
      }
    })
    return previousValue + notRevoked;
  }, 0);

  return (
    <div className='row h-100'>
      <div className='col-3 h-100'>
        <div className='card overflow-hidden h-100'>
          <div className='card-header border-bottom sticky-top'>
            <Toolbar heading={`${nUsers} ${translate('OTM_NOTIFICATIONS_USERS')}, ${nRegistrations} ${translate('OTM_NOTIFICATIONS_REGISTRATIONS')}`} />
          </div>
          <div className='card-body overflow-auto h-100 pt-0'>
            <div className="sticky-top pt-3 mb-2 bg-white">
              <SearchBar
                ref={ref}
                size="sm"
                initialValue={searchPrompt}
                placeholder={translate("OTM_SEARCH")}
                onChange={(value) => setSearchPrompt(value)} />
            </div>
            <List
              data={userIds.filter(userId => userId.toLowerCase().includes(searchPrompt.toLowerCase())).map((userId) => ({ _id: userId, userId }))}
              attr='userId'
              selectedElement={objectSubTypeId}
              onClick={(eventKey) => history.push(`${baseUrl}/${eventKey}`)}
            />
          </div>
        </div>
      </div>
      <div className='col-9 h-100'>
        {objectSubTypeId && notificationsData[objectSubTypeId] && <UserDetails userId={objectSubTypeId} registrationsData={notificationsData[objectSubTypeId]} />}
      </div>
    </div>
  );
};

export default UserNotifications;